import { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Box, Drawer, IconButton, Typography } from '@mui/material'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

import styles from './styles'

const ModalMobileFullHeightContent = ({ children }) => {
  return <Box sx={styles.isFullHeightContent}>{children}</Box>
}

ModalMobileFullHeightContent.propTypes = {
  children: PropTypes.node,
}

const ModalMobile = ({
  title,
  isOpen,
  onClose,
  children,
  isFullHeight,
  isFiltersModal,
  anchor,
}) => {
  const DrawerContent = isFullHeight ? ModalMobileFullHeightContent : Fragment

  return (
    <Drawer open={isOpen} onClose={onClose} anchor={anchor}>
      <DrawerContent>
        <Box
          sx={{
            ...styles.header,
            ...(isFiltersModal ? styles.isFiltersHeader : {}),
          }}
        >
          <Typography variant="h2">{title}</Typography>
          <IconButton onClick={onClose} sx={styles.closeButton}>
            <X />
          </IconButton>
        </Box>
        <Box sx={styles.innerContent}>{children}</Box>
      </DrawerContent>
    </Drawer>
  )
}

ModalMobile.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  isFullHeight: PropTypes.bool,
  isFiltersModal: PropTypes.bool,
  anchor: PropTypes.string,
}

export default ModalMobile
